module.exports = __webpack_public_path__ + "static/media/fin5.039947f7.jpg";